import React from "react";
import BaseComponent from "../../../base/BaseComponent";

export default class weibo extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn,
            btnColor: window.sysConfig && window.sysConfig.getValueByKey("newSecondSelectColor", '#0050B3')||'#0050B3',
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    show() {
        this.setState({hideBtn: false});
    }

    render() {
        let obj;
        let {btnColor} = this.state;
        if (this.props.btnName && this.props.btnName.indexOf("提交") > -1) {
            obj = {
                color: "#fff",
                bgColor: btnColor,
                borderColor: btnColor,
                letterSpacing: "2px",
                paddingLeft: "2px"
            }
        } else {
            obj = {
                color: btnColor,
                bgColor: "#fff",
                borderColor: "rgba(0, 0, 0, 0.15)",
                letterSpacing: "2px",
                paddingLeft: "2px"
            }
        }
        return (
            this.state.hideBtn ? "" :
                <div className={"weiboBtn"} style={{
                    width: "auto",
                    height: 32,
                    cursor: "pointer",
                    marginRight: 16,
                    padding: "5px 10px",
                    color: obj.color,
                    fontWeight: 400,
                    fontSize: "14px",
                    textAlign: "center",
                    background: obj.bgColor,
                    borderRadius: "4px",
                    border: `1px solid ${obj.borderColor}`
                }} onClick={this.props.onClick}>
                    <span style={{
                        letterSpacing: obj.letterSpacing,
                        paddingLeft: obj.paddingLeft
                    }}>{this.props.btnName}</span>
                </div>
        )
    }

}